export function getCompany(payload) {
  return {
    type: "@company/GET_COMPANY",
    payload,
  };
}
